@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  html {
    direction: rtl;
    @apply font-sans;
  }

  body {
    @apply bg-slate-50 text-slate-900;
  }

  * {
    box-sizing: border-box;
  }

  a {
    @apply transition-colors;
  }
}

@layer components {
  .page-shell {
    @apply min-h-screen bg-[radial-gradient(circle_at_top_right,_rgba(6,182,212,0.16),_transparent_32%),radial-gradient(circle_at_bottom_left,_rgba(15,118,110,0.12),_transparent_28%),linear-gradient(to_bottom,_#f8fafc,_#f1f5f9)];
  }

  .glass-card {
    @apply rounded-3xl border border-white/70 bg-white/85 shadow-soft backdrop-blur;
  }

  .section-title {
    @apply text-lg font-semibold text-slate-900;
  }

  .muted {
    @apply text-sm text-slate-500;
  }

  .input-base {
    @apply w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-right text-slate-900 shadow-sm outline-none transition focus:border-brand-500 focus:ring-4 focus:ring-brand-100;
  }

  .label-base {
    @apply mb-2 block text-sm font-medium text-slate-700;
  }

  .btn-primary {
    @apply inline-flex items-center justify-center rounded-2xl px-4 py-3 font-medium text-white shadow-soft transition hover:opacity-95 focus:outline-none focus:ring-4 focus:ring-brand-100;
  }

  .btn-secondary {
    @apply inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-white px-4 py-3 font-medium text-slate-700 shadow-sm transition hover:bg-slate-50;
  }

  .chip {
    @apply inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-700;
  }

  .card-content {
    background: var(--template-page) !important;
    color: var(--template-text) !important;
  }

  .card-content .section-title {
    color: var(--card-primary);
  }

  .card-section {
    border-radius: var(--template-radius);
    background: var(--template-panel) !important;
    color: var(--template-text) !important;
    box-shadow: var(--template-shadow);
  }

  .card-template-clean {
    --template-page: #f8fafc;
    --template-panel: #ffffff;
    --template-text: #0f172a;
    --template-radius: 2rem;
    --template-shadow: 0 1px 2px rgb(15 23 42 / 0.05);
  }

  .card-template-warm {
    --template-page: #fff7ed;
    --template-panel: #fffdf8;
    --template-text: #431407;
    --template-radius: 2.5rem;
    --template-shadow: 0 12px 30px rgb(124 45 18 / 0.08);
  }

  .card-template-dark {
    --template-page: #0f172a;
    --template-panel: #1e293b;
    --template-text: #e2e8f0;
    --template-radius: 1.5rem;
    --template-shadow: 0 12px 30px rgb(2 6 23 / 0.3);
  }

  .card-template-editorial {
    --template-page: #f4f1ea;
    --template-panel: #fffdf8;
    --template-text: #292524;
    --template-radius: 0.75rem;
    --template-shadow: 0 8px 24px rgb(68 64 60 / 0.1);
  }

  .card-template-bold {
    --template-page: #eef2ff;
    --template-panel: #ffffff;
    --template-text: #1e1b4b;
    --template-radius: 1.25rem;
    --template-shadow: 0 16px 36px rgb(49 46 129 / 0.12);
  }

  .card-template-warm > .mx-auto {
    max-width: 46rem;
  }

  .card-template-warm .card-content {
    position: relative;
    margin-top: -2rem;
    border-radius: 2.5rem 2.5rem 0 0;
  }

  .card-template-warm .card-section {
    border-radius: 2.5rem 1rem 2.5rem 1rem;
  }

  .card-template-dark .card-content {
    margin-top: 0;
    box-shadow: none;
  }

  .card-template-dark .card-section {
    border: 1px solid rgb(148 163 184 / 0.18);
  }

  .card-template-editorial > .mx-auto {
    max-width: 64rem;
  }

  .card-template-editorial .card-content {
    display: grid;
    gap: 1.25rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    border-radius: 0;
  }

  .card-template-editorial .card-content > section {
    margin-top: 0 !important;
  }

  .card-template-editorial .card-content > section:last-child {
    grid-column: 1 / -1;
  }

  .card-template-bold > .mx-auto {
    max-width: 52rem;
  }

  .card-template-bold .card-content {
    display: grid;
    gap: 0.75rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .card-template-bold .card-section {
    border: 2px solid rgb(99 102 241 / 0.12);
  }

  .card-template-bold .card-content > section {
    margin-top: 0 !important;
  }

  .card-template-bold .card-content > section:first-child,
  .card-template-bold .card-content > section:last-child {
    grid-column: 1 / -1;
  }

  .card-template-warm .card-hero-content,
  .card-template-editorial .card-hero-content {
    align-items: flex-start;
    text-align: right;
  }

  @media (max-width: 767px) {
    .card-template-editorial .card-content {
      display: block;
    }

    .card-template-bold .card-content {
      display: block;
    }

    .card-template-editorial .card-content > section,
    .card-template-bold .card-content > section {
      margin-top: 2rem !important;
    }
  }
}
